import {PortfolioRepo} from '../../../portfolio/portfolio.repo'
import * as _ from 'lodash'
import * as angular from 'angular'
import moment = require('moment');


class PerformanceParameterDialogController {

    

    public performanceParameters : any[];
    public portfolioId : any;
    public locality : any;
    public performanceDate : any;
    public comment : any;
    public overriddenBy : any;
    public overriddenOn : any;
    public isOverridden : any;

    public isEditing : boolean = false;
    
    public performanceUpdateForm: ng.IFormController;
    public openingBalanceRates: any[];
    public closingBalanceRates: any[];
    
    /** @ngInject */
    constructor(private $mdDialog: angular.material.IDialogService,private portfolioRepo : PortfolioRepo, private notifyjs) {
        
    }

    $onInit(){
        this.portfolioRepo.getMonthlyPerformanceParameters(this.portfolioId, this.locality, this.performanceDate)
        .then ((res)=>{
            this.performanceParameters = res.data as Array<any>;

            _.forEach(this.performanceParameters, (performanceParameter)=>{
                performanceParameter.performance = +(performanceParameter.performance * 100).toFixed(5);
                performanceParameter.initialOpeningBalance = performanceParameter.openingBalance;
                performanceParameter.initialClosingBalance = performanceParameter.closingBalance;
            })
            let firstPerformanceParameters = _.first(this.performanceParameters) as any;
            if(firstPerformanceParameters.isOverridden){
                this.comment = firstPerformanceParameters.comment
                this.overriddenBy = firstPerformanceParameters.overriddenBy.name;
                this.overriddenOn = firstPerformanceParameters.overriddenOn;
                this.isOverridden = true;
            }else{
                this.comment = "";
            }
        })
        const closingRatesDay = moment(this.performanceDate).endOf('day').format("YYYY-MM-DD");
        const openingRatesDay = moment(this.performanceDate).add(-1, 'month').endOf('month').format("YYYY-MM-DD");

        this.portfolioRepo.getExhangeRatesForDay(closingRatesDay)
            .then((res) => {
                this.closingBalanceRates = res.data as Array<any>
            })
        this.portfolioRepo.getExhangeRatesForDay(openingRatesDay)
        .then((res) => {
            this.openingBalanceRates = res.data as Array<any>
        })
    }

    onOpeningBalanceChange(performanceParameter) {
        this.performanceParameters.filter(pp => pp.currency !== performanceParameter.currency).forEach(pp => {
            const exchangeRate = this.openingBalanceRates.find(er => er.currencyFrom === performanceParameter.currency && er.currencyTo === pp.currency);
            pp.openingBalance = Number((performanceParameter.openingBalance * exchangeRate.rate).toFixed(2));
        })
    }
  
    onClosingBalanceChange(performanceParameter) {
        this.performanceParameters.filter(pp => pp.currency !== performanceParameter.currency).forEach(pp => {
            const exchangeRate = this.closingBalanceRates.find(er => er.currencyFrom === performanceParameter.currency && er.currencyTo === pp.currency);
            pp.closingBalance = Number((performanceParameter.closingBalance * exchangeRate.rate).toFixed(2));
        })
    }
    save(){

        let performanceParametersPayload ;
        performanceParametersPayload = angular.copy(this.performanceParameters);
        performanceParametersPayload.forEach((performanceParameter)=>{
            performanceParameter.comment = this.comment;
            performanceParameter.performance = +(+performanceParameter.performance/100).toFixed(5);
        })
        

        this.portfolioRepo.updatePerformanceParameters(this.portfolioId,this.locality,performanceParametersPayload)
        .then((res)=>{
            this.$mdDialog.hide(true);
        })
        .catch((err)=>{
            this.notifyjs(`Failed to update performance : ${err.data}`)
        })
    }
    
    cancel() {
      this.$mdDialog.hide();
    }

  }
  
  export const performanceParameterDialog: angular.IComponentOptions = {
    template: require('./updatePerformanceParameter.dialog.html'), 
    controller: PerformanceParameterDialogController,
    bindings: {
        portfolioId : "<",
        locality : "<",
        performanceDate : "<"
      }

  }
  


// WEBPACK FOOTER //
// ./src/app/portfolioadmin/performanceManagement/updatePerformanceParameterDialog/updatePerformanceParameter.dialog.ts